<!-- <app-header></app-header> -->

<div class="assign-container fluid-container">
    <!-- <div><app-sidebar-chatbot></app-sidebar-chatbot></div> -->
    <div class="top-right-div">
    <div class="top-row">
        <div class="left-titl-buton ">
            <div class="back-btn" (click)="backbutton()">
              <img  src="../../../assets/images/back_button_popup.svg" alt="Back-Button">
            </div>
            <div class="title">
                Users - {{ dataSource.data.length }} Members
            </div>
        </div>
        <div class="right-filter">
          <div class="input-pos">
            <input matInput #searchInput  placeholder="Search with ..." class="filter-search" (input)="applyFilter(searchInput.value)">
            <i class="fa fa-search search-icon"></i>
          </div>
            <div *ngIf="showNoSearchResultsMessage">
              No search results found.
            </div>
        </div>
        
    </div>
    <div class="bottom-table">
        <div>
            <table class="assignee-table mat-elevation-z11" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="wwid">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        WWID
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.wwid}} </td>
                  </ng-container>
                  <!-- <ng-container matColumnDef="avtar_enabled">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Avatar
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-slide-toggle [checked]="element.avtar_enabled" (change)="toggle(element.wwid, $event.checked)">
                      </mat-slide-toggle>
                    </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="allocated_time">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                       Avatar Quota Balance
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td " > {{element.allocated_time}} </td>
                  </ng-container>
                  <ng-container matColumnDef="pending_time">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                       Consumed Quota
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td " >{{element.pending_time}}  </td>
                  </ng-container> -->
                  <ng-container matColumnDef="first_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        First Name
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td name" (click)="userinfo(element.wwid, element.allocated_time, element.pending_time)"> {{element.first_name}} </td>
                  </ng-container>

                  <ng-container matColumnDef="last_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Last Name
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td" (click)="userinfo(element.wwid, element.allocated_time, element.pending_time)"> {{element.last_name}} </td>
                  </ng-container>

                  <ng-container matColumnDef="session_count">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Chats
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.session_count}} </td>
                  </ng-container>

                  <!-- <ng-container matColumnDef="roleplay_completed">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Roleplays
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td">
                         {{(element.roleplay_completed !== null)? element.roleplay_completed !== null:0}} {{element.roleplay_completed}} - {{element.roleplay_total_count}} Completed</td>
                         {{ element.roleplay_completed !== null && element.roleplay_total_count !== null ? element.roleplay_completed + ' - ' + element.roleplay_total_count + ' Completed' : '0 - 0 Completed' }}

                        
                  </ng-container> -->
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Email
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.email}} </td>
                  </ng-container>
                  <ng-container matColumnDef="last_login">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Last login
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ convertUtcToLocal(element.last_login) | date: 'MM-dd-yyyy hh:mm a' }} </td>
                  </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
            </mat-paginator>

        </div>
    </div>
</div>

</div>